module.exports = __webpack_public_path__ + "img/NDZ_Apple.bdad9748.svg";